const userCellHeaders = [
    { id: 'name', label: 'Name', align: 'left' },
    { id: 'company', label: 'Company', align: 'left' },
    { id: 'role', label: 'Role', align: 'left' },
    { id: 'isVerified', label: 'Verified', align: 'left' },
    { id: 'status', label: 'Status', align: 'left' },
    { id: '' }
  ];
  
export default userCellHeaders;